export const INTERNAL_IDENTITIES_URL = "/internal/identities";

export const CARDHOLDER_ONBOARDING_ROUTE = "/app/cardholder-onboarding";

export const CARDHOLDER_BOARD_PAGE_SIZE = 25;
